import { FC } from 'react';
import { useSelector } from 'react-redux';
import classNames from '../../../../../utils/classnames';
import CheckImg from '../../../../../images/check-grey.svg';
import { AVAILABLE_PAYMENT_METHODS } from '../../../payment.constants';
import { PAYMENT_METHOD_KEYS } from '../../../../../constants/payment-method-keys';
import SchoolAccount from '../../../../../utils/school-account';
import translation from '../../../../../languages';
import { PaymentOptionType } from '../../../../../utils/enhanced-ecommerce';
import useHasSelectedPaymentMethod from '../../../hooks/use-has-selected-payment-method';

type PaymentOptionProps = TranslationProps & {
    paymentMethod: PaymentOptionType;
    isActive: boolean;
    onClick: (paymentMethod: PaymentOptionType) => void;
};

const PaymentOption: FC<PaymentOptionProps> = ({ t, ...props }) => {
    const user = useSelector((state: RootState) => state.main.user);
    const { paymentOptionsAvailability } = useSelector((state: RootState) => state.payment);
    const paymentMethodName = Object.keys(AVAILABLE_PAYMENT_METHODS).find(methodName => AVAILABLE_PAYMENT_METHODS[methodName].id === props.paymentMethod.id);
    const hasSelectedPaymentMethod = useHasSelectedPaymentMethod();
    const optionErrorClass = hasSelectedPaymentMethod ? '' : 'error';

    const formMethodTitle = (paymentMethod: PaymentOptionType) => {
        if (paymentMethod.id === AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD].id) {
            return t('payment.paymentForm.creditCard');
        }

        return paymentMethod.title;
    };

    const formMethodDescription = (paymentMethod: PaymentOptionType) => {
        if (paymentMethod.id === AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.AMAZON_PAY].id) {
            return t('payment.paymentMethodSelection.optionDescriptions.amazonPay');
        }

        if (paymentMethod.id === AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT_CREDIT_CARD].id) {
            return t('payment.paymentMethodSelection.optionDescriptions.creditCard');
        }

        if (paymentMethod.id === AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.PAYPAL_CHECKOUT].id) {
            return t('payment.paymentMethodSelection.optionDescriptions.paypal');
        }

        if (paymentMethod.id === AVAILABLE_PAYMENT_METHODS[PAYMENT_METHOD_KEYS.INVOICE].id && SchoolAccount.isAdmin(user)) {
            return t('payment.paymentMethodSelection.optionDescriptions.invoice');
        }

        return '';
    };

    return paymentMethodName && paymentOptionsAvailability?.get(paymentMethodName as PAYMENT_METHOD_KEYS) ? (
        <div
            key={props.paymentMethod.id}
            className={classNames('payment-option d-flex', optionErrorClass, {
                active: props.isActive
            })}
            onClick={() => props.onClick(props.paymentMethod)}
        >
            <div className='image-holder d-flex justify-content-center align-items-center'>
                <img src={props.paymentMethod.img} alt='' />
            </div>
            <div className='flex-1'>
                <label htmlFor={props.paymentMethod.id}>{formMethodTitle(props.paymentMethod)}</label>
                <div className='description'>{formMethodDescription(props.paymentMethod)}</div>
                <img className='check' src={CheckImg} alt='' />
            </div>
        </div>
    ) : <></>;
};

const translate = translation('payment');

export default translate(PaymentOption);
